
(function pdfViewerModuleDefinition(){

    angular.module('PDFViewer', ['Language']);

})();